import React from 'react';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';
import DatePicker from './date_picker';

const DatePickerControlled = (props) => {
    const { control, name, rules } = props;

	return (
        <Controller
            name={name}
            control={control}
            rules={rules}
            defaultValue={null}
            render={() => (
                <DatePicker
                    {...props}
                />
            )}
        />
	);
}

DatePickerControlled.propTypes = {
    control: PropTypes.object,
    name: PropTypes.string,
    rules: PropTypes.object
}

export default DatePickerControlled;
